import { createSlice } from "@reduxjs/toolkit";

import { ProcessingStatus } from "@/features/intelliflow/constants/documentParser.constants";
import {
  UploadTaskRecord,
  uploadQueueDb,
} from "@/features/intelliflow/db/uploadQueueDb";

const uploadSlice = createSlice({
  name: "uploadQ",
  initialState: [] as UploadTaskRecord[],
  reducers: {
    addTask: (state, action) => {
      state.push(action.payload);
    },
    updateTask: (state, action) => {
      const index = state.findIndex((t) => t.id === action.payload.id);
      if (index !== -1) {
        const currentStatus = state[index].status;
        const newStatus = action.payload.status;
        const now = Date.now();

        if (newStatus && currentStatus !== newStatus) {
          if (
            currentStatus === ProcessingStatus.PENDING &&
            [
              ProcessingStatus.UPLOADING,
              ProcessingStatus.UPLOADED,
              ProcessingStatus.EXTRACTING,
              ProcessingStatus.EXTRACTED,
              ProcessingStatus.PROCESSING_AI,
            ].includes(newStatus)
          ) {
            action.payload.startedAt = now;
          }
          if (
            currentStatus === ProcessingStatus.UPLOADING &&
            [
              ProcessingStatus.UPLOADED,
              ProcessingStatus.EXTRACTING,
              ProcessingStatus.EXTRACTED,
              ProcessingStatus.PROCESSING_AI,
            ].includes(newStatus) &&
            !state[index].startedAt
          ) {
            action.payload.startedAt = now;
          }

          if (
            [
              ProcessingStatus.COMPLETED,
              ProcessingStatus.FAILED,
              ProcessingStatus.DUPLICATE,
              ProcessingStatus.UN_SUPPORTED_FORMAT,
            ].includes(newStatus)
          ) {
            action.payload.completedAt = now;
          }
        }

        state[index] = {
          ...state[index],
          ...action.payload,
        };
      }
    },
    removeTask: (state, action) => {
      state.filter((t) => t.id !== action.payload);
      void uploadQueueDb.uploads.delete(action.payload);
    },
    loadFromDb: (_, action) => action.payload,
    clearAllTask: (state) => {
      state.length = 0;

      return state;
    },
  },
});

export const { addTask, updateTask, clearAllTask } = uploadSlice.actions;

export default uploadSlice.reducer;
